// extracted by mini-css-extract-plugin
export default {"wrapper":"LegacyFilesPage_wrapper__gMMrc","suspense-loader-wrapper":"LegacyFilesPage_suspense-loader-wrapper__EVs9I"};